import { render, staticRenderFns } from "./HelpdeskForm.vue?vue&type=template&id=aca5659e&scoped=true"
import script from "./HelpdeskForm.vue?vue&type=script&lang=js"
export * from "./HelpdeskForm.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskForm.vue?vue&type=style&index=0&id=aca5659e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca5659e",
  null
  
)

export default component.exports